
import React from "react";
import {  useRef, useEffect } from "react"

const Logina = ({instance,hash}) => {
    const tenantRef = useRef(null);
    const userRef = useRef(null);

    useEffect(() => {
        let theInstance =instance;
        setTimeout(() => {
            if(typeof theInstance === "undefined"){
                window.location.reload();
                return;
            }                
        }, 420);

        try {
            let host = window.location.host.split(".");
            if (host.length == 3) {
                tenantRef.current.value = host[0];
                userRef.current.focus();
            } else {
                tenantRef.current.focus();
            }
        } catch (e) {/**/ }
    // eslint-disable-next-line 
    }, []);


    return (
        <>

            { hash ? <></>:
            <>
                <div className="login-window" style={{
                    justifyContent: window.innerWidth > 500 ? "center" : "center",
                    height: "calc(100vh)",
                    marginLeft: 0,
                }} >

<div style={{
                background: "url(./img/bigappf.svg) no-repeat",
                backgroundSize: "100vw",
                backgroundColor:"transparent",
                backgroundPosition: "bottom",
                position: "absolute",
                bottom: 0,
                left: 0,
                // backgroundColor: "rgba(255,0,0,0.5)",
                width: "100%",
                height: "100%",
                zIndex: -1,
            }}>

            </div>


                    <div className="aform seethrough" style={{
                        paddingBottom: window.innerWidth > 500 ? "62px" : "0",
                    }}>
                               <div style={{
                        marginLeft: 20,
                        marginTop: -4,
                        paddingBottom: 4,
                        minWidth: 120,
                        minHeight: 64,
                        // border:"1px solid rgba(255,255,255,0.42)",
                        background:"url(./img/appflogonew.svg) no-repeat",
                        backgroundSize: "182px",
                    }} >

                    </div>
                        <form style={{ 
                        paddingLeft: 10, paddingBottom: 120 }}>
                        <div style={{
                                marginLeft:110,
                                marginTop:258,
                                // lineHeight:1.9,
                                fontFamily:"InterL",
                                fontSize:12,
                                color:"rgba(255,255,255,0.64)",
                                position:"absolute",
                                textAlign:"right"
                            }}>
                                You will be redirected <br/>to sign in page.
                            </div>

                        </form>
                        <div style={{
                                    background: "url(./img/azu.svg) no-repeat",
                                    zIndex:99,
                                    backgroundSize: 42,
                                    width: 200,
                                    height: 200,
                                    right: -120,
                                    top: 342,
                                    position: "absolute"
                                }}>
                                </div>
                        <div className="appf-loginc" style={{
                            visibility: (typeof instance === "undefined") ? "hidden" : "visible",
                            position:"fixed",
                            minWidth:220,
                            marginLeft:60,
                            bottom:189,
                        }}>
                            <button id={`appf-login`} className="appf-login abutton"
                            style={{
                            }} onClick={
                                async ()=>{

                                if( sessionStorage["msal.interaction.status"] ){
                                    Object.keys(sessionStorage).forEach((k)=>{
                                        delete sessionStorage[k];
                                    })
                                }

                                let client_id =""
                                try{
                                    client_id = JSON.parse(localStorage.appf_tenant_info ).client_id;
                                } catch(e){
                                    client_id =""
                                }
                                
                                if(typeof instance === "undefined"){
                                    window.location.reload();
                                    return;
                                }

                                await instance.initialize().then(()=>{
                                    instance.loginRedirect({
                                        scopes: [`${client_id}/user.read`],
                                        prompt: "select_account"
                                    })
                                    .catch((error) => console.log(error));
                                })
                            }}
                            >SIGN IN</button>
                        </div>
                    </div>
                </div>
            </>
            }
        </>
    );
};

const Login = ({ instance, hash }) => {
    return (<Logina hash={hash} instance={instance}></Logina>);
};

export default Login;